import { Attrs, MinzeElement } from 'minze'

export interface LvcAccountHeartIcon {
  width: number
  height: number
}

export class LvcAccountHeartIcon extends MinzeElement {
  attrs: Attrs = [
    ['width', 30],
    ['height', 30],
  ]
  html = () => `
    <svg width="${this.width}" height="${this.height}" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M14.2102 7.35363C13.6514 6.36919 12.8242 5.58015 11.8329 5.0902C10.7683 4.56406 9.57077 4.41067 8.4168 4.65266C7.15116 4.86788 5.97619 5.47662 5.04394 6.40011C4.1117 7.32361 3.46505 8.51936 3.1877 9.83265C3.01869 11.0697 3.3183 12.3271 4.02233 13.3352C4.95403 14.6404 5.96153 15.8841 7.03911 17.0593L10.9107 21.5324C11.8786 22.9123 13.0617 24.1108 14.4101 25.0772C14.4668 25.1041 14.5311 25.108 14.5903 25.088C14.5932 25.0871 14.596 25.0861 14.5988 25.085C14.6891 25.1422 14.8103 25.1529 14.913 25.0667V25.035C16.9473 23.2999 18.8409 21.3908 20.5745 19.3275C22.2422 17.5191 23.6026 15.4246 24.5969 13.1348C25.02 12.1332 25.1957 11.036 25.1078 9.94446C25.0199 8.85288 24.6713 7.80213 24.0941 6.88924C23.558 6.06532 22.84 5.38949 22.0014 4.91926C21.1627 4.44903 20.2282 4.19833 19.2773 4.18848C18.1986 4.2184 17.1472 4.55131 16.2328 5.15251C15.3961 5.70258 14.7022 6.45884 14.2102 7.35363ZM14.2102 7.35363C14.5583 8.28022 14.6127 9.30375 14.3597 10.2707" stroke="currentColor" stroke-width="1.35" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  `
}
